import React, { useState } from "react";
import "../css/Gallery.css"

const Gallery = ({ images }) => {
	const [lightbox, setLightbox] = useState({ open: false, index: 0 });

	const openLightbox = (idx) => setLightbox({ open: true, index: idx });
	const closeLightbox = () => setLightbox({ open: false, index: 0 });

	const prevImage = () =>
		setLightbox((prev) => ({
			...prev,
			index: (prev.index - 1 + images.length) % images.length,
		}));

	const nextImage = () =>
		setLightbox((prev) => ({
			...prev,
			index: (prev.index + 1) % images.length,
		}));

	return (
		<div className="gallery-container">
			<div className="gallery-grid">
				{images.map((img, idx) => (
					<div
						key={idx}
						className="gallery-item"
						onClick={() => openLightbox(idx)}
					>
						<img src={img} alt={`Image ${idx}`} />
					</div>
				))}
			</div>

			{lightbox.open && (
				<div className="lightbox" onClick={closeLightbox}>
					<button
						className="navi prev"
						onClick={(e) => {
							e.stopPropagation();
							prevImage();
						}}
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
							<path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
						</svg>
					</button>

					<img
						src={images[lightbox.index]}
						alt={`Large ${lightbox.index}`}
						className="lightbox-image"
					/>

					<button
						className="navi next"
						onClick={(e) => {
							e.stopPropagation();
							nextImage();
						}}
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
							<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
						</svg>
					</button>
				</div>
			)}
		</div>
	);
};

export default Gallery;
